import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// 쿼리
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Reset } from "styled-reset";

// 개발전용
import Dev from "./Dev";
// const DEV = true;
const DEV = process.env.REACT_APP_MODE === "dev";
// 개발전용

const root = ReactDOM.createRoot(document.getElementById("root"));
const queryClient = new QueryClient();
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Reset />
      {DEV ? <Dev /> : <App />}
    </QueryClientProvider>
  </React.StrictMode>,
);

reportWebVitals();
